import React from 'react'
import * as requestFormType from './newProjectType'

import { RoutePath } from '../../../../../../router/routesConfig'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import { generatePath, useHistory } from 'react-router-dom'

import useWebService from '../../../../../../services/web/useWebService'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useLoading from '../../../../../../control/loading/useLoading'
import { topicForLecturer, topicForStudent } from '../../../../../../constants/constants'
import constSubmittedType from '../../../../../../constants/submittedType'

import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import * as REQServiceTypes from '../../../../../../services/web/types/requestWebServiceTypes'
import _ from 'lodash'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'
import { encryptionAES } from '../../../../../../utilities/encryption'
import useTranslate from '../../../../../../i18n/useTranslate'
import { ResultDocumentTopicLut } from '../../../../../../services/lookup/types/responseLookupServiceTypes'
import useProjectHook from '../../../../shareLogic/useProjectHook'
import useFolderAndTab from '../../../useFolderAndTab'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import {
    withFileTokenInfo,
    trimEmplyFileInfo,
    checkAllAdditionalDocTopicsHavePdf,
} from '../../../../../../utilities/additionalDoc'

type UploadFileObjType = {
    uploadFileObj: {
        documentTopicID: number

        fileList: {
            documentTopicID: number
            fileID: any
            fileToken: string
            filename: string
            path: string
        }[]

        subTopicPageList?: {
            page: string
            documentTopicID: number
            subtopicID: number
        }[]
    }
}

type MyFileDataType = {
    documentTopicID?: number
    fileTokenInfo: Array<{
        replaceFileID: number
        fileToken: string
        fileExtension?: string
        fileID: any
    }>
    subtopic?: {
        subtopicID: number
        page: number | string
    }[]
}

const useRequestForm = (props: requestFormType.UseRequestFormType) => {
    const { formMode, projectSubmittedTypeID, isViewMode, initialData, onSaveComplete } = props

    const translate = useTranslate()
    const authenStore = useAuthenStore()
    const projectHook = useProjectHook()
    const tabAndFolderHook = useFolderAndTab()
    const checkPermission = useCheckPermission()

    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()

    const { profile } = authenStore

    const { configLoading, loadingClose, loadingOpen } = useLoading()
    const callWebService = useWebService()
    const history = useHistory()
    const callLookup = useLookupService()
    const [selectedIrb, setSelectedIrb] = React.useState<string | undefined>('1')

    const dialogTwoRef = React.useRef<Record<string, Function>>()
    const projectIDRef = React.useRef<number>()
    const submittedIDRef = React.useRef<number>()
    const irbRef = React.useRef<number>()
    const parameterForSaveRef = React.useRef<any>()
    const submitValueRef = React.useRef<any>()
    const isDraftRef = React.useRef<boolean>(false)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const { documentTopic } = manageProjectStore
    const researcherTypeRef = React.useRef<string>()
    const documentTopicRef = React.useRef<ResultDocumentTopicLut[]>()
    const valuesForm = React.useRef<requestFormType.MyRequestFormType>()
    const tabSelectedIndexRef = React.useRef<number | null>(null)
    const newTabSelectedRef = React.useRef<any>(null)
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()
    const [initialDataValue, setInitialDataValue] = React.useState<any>()

    let isApproveWithComment = false
    if (manageProjectStore.projectData) {
        isApproveWithComment = projectHook.isFlowApproveWithComment(manageProjectStore.projectData)
    }

    React.useEffect(() => {
        console.log('####Page: New Project####')
        if (manageProjectStore.projectData?.irb) {
            const rec = manageProjectStore.projectData.irb.toString()
            handleChangeFaculty(rec)
        } else if (profile.userId && !profile.isCunet) {
            const rec = '1'
            handleChangeFaculty(rec)
        }
        return () => {
            //clear ค่า tabRef
            tabSelectedIndexRef.current = null
            newTabSelectedRef.current = null
        }
    }, [])

    React.useEffect(() => {
        if (manageProjectStore.projectData?.irb && manageProjectStore.projectData?.submitTypeInfo.value) {
            getDocumentTopicLut(
                manageProjectStore.projectData?.irb,
                manageProjectStore.projectData?.submitTypeInfo.value,
            )
        }
    }, [manageProjectStore.projectData?.submittedID])

    React.useEffect(() => {
        createInitialUploadFile()
    }, [
        manageProjectStore.documentTopic,
        JSON.stringify(manageProjectStore.projectData?.documentInfo),
        JSON.stringify(manageProjectStore.projectData?.latestDocument),
    ])

    React.useEffect(() => {
        createInitialValue()
    }, [initialData])

    const createInitialValue = () => {
        const initialDataForm = {
            ...initialData,
            researchProjectSummaryTH: initialData?.researchProjectSummaryTH ?? null,
            researchProjectSummaryEN: initialData?.researchProjectSummaryEN ?? null,
            coResearcher: initialData?.coResearcher
                ? initialData?.coResearcher?.map((e: any) => {
                      return {
                          ...e,
                          titleName: e.titleNameId ? e.titleNameId.toString() : null,
                          academicPosition: e.academicPositionId ? e.academicPositionId.toString() : null,
                          otherTitleNameTH: e.otherTitleNameTh ?? null,
                          otherTitleNameEN: e.otherTitleNameEn ?? null,
                          otherAcademicPositionTH: e.otherAcademicPositionTh ?? null,
                          otherAcademicPositionEN: e.otherAcademicPositionEn ?? null,
                          isDr: e.isAcademicPhd ?? null,
                          nameEN: e.nameEn ?? null,
                          nameTH: e.nameTh ?? null,
                          homePhone: e.homePhoneNumber ?? null,
                          mobilePhone: e.phoneNumber ?? null,
                      }
                  })
                : [
                      {
                          researcherRoleTypeId: 1,
                          isDr: initialData?.isDr ?? profile.isPhD,
                          nameTH: initialData?.nameTH ?? profile.only_name_th,
                          nameEN: initialData?.nameEN ?? profile.only_name_en,
                          mobilePhone: initialData?.mobilePhone ?? profile.mobilePhone,
                          email: initialData?.email ?? profile.email,
                          academicPosition: initialData?.academicPosition ?? profile.academicPositionID?.toString(),
                          titleName: initialData?.titleName ?? profile.titleNameID?.toString(),
                          otherTitleNameEN:
                              initialData?.otherTitleNameEN || initialData?.otherTitleNameEN === null
                                  ? initialData.otherTitleNameEN
                                  : profile.titleNameID
                                  ? profile.titleNameOther_en
                                  : null,
                          otherTitleNameTH:
                              initialData?.otherTitleNameTH || initialData?.otherTitleNameTH === null
                                  ? initialData.otherTitleNameTH
                                  : profile.titleNameID
                                  ? profile.titleNameOther_th
                                  : null,
                          otherAcademicPositionTH:
                              initialData?.otherAcademicPositionTH || initialData?.otherAcademicPositionTH === null
                                  ? initialData.otherAcademicPositionTH
                                  : profile.academicPositionID
                                  ? profile.academicPositionOther_th
                                  : null,
                          otherAcademicPositionEN:
                              initialData?.otherAcademicPositionEN || initialData?.otherAcademicPositionEN === null
                                  ? initialData.otherAcademicPositionEN
                                  : profile.academicPositionID
                                  ? profile.academicPositionOther_en
                                  : null,
                      },
                  ],
        }

        if (initialData?.IRB?.value) {
            researcherTypeRef.current = initialData?.IRB?.value
        }
        setInitialDataValue(initialDataForm)
    }

    const getDocumentInfo = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceTypes.DocumentInfo> = []

        fileDataList.forEach((uploadObj: UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            // const fileTokenInfo: Array<string> = uploadObj.uploadFileObj.fileList?.map((file) => file.fileToken) ?? []
            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: number
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }

    const getStrVal = (v: any | undefined | null): string | null => {
        if (v == null) return null
        if (typeof v === 'string' || typeof v === 'number') return String(v)
        if (typeof v === 'object' && 'value' in v) return v.value != null ? String(v.value) : null
        return null
    }

    const getParameterForSave = (value: requestFormType.MyRequestFormType) => {
        // helper: รับค่าได้ทั้ง string หรือ { value: string }

        // normalize
        const researcherTypeVal = getStrVal(value.researcherType) // '1' = student? ตามระบบคุณ
        const isStudent = researcherTypeVal === '1'
        const irbVal = getStrVal(value.IRB)
        const educationLevelVal = getStrVal(value.educationLevel)

        let submittedTypeID = projectSubmittedTypeID
        if (manageProjectStore?.projectData?.submitTypeInfo?.value) {
            submittedTypeID = manageProjectStore.projectData.submitTypeInfo.value
        }

        const documentAdditionalInfo = withFileTokenInfo(trimEmplyFileInfo(value.documentAdditionalInfo))

        const parameterForSave: REQServiceTypes.CreateProjectRequestType = {
            projectID: manageProjectStore?.projectData?.projectID ?? null,
            submittedID: manageProjectStore?.projectData?.submittedID ?? null,
            irb: irbVal ? parseInt(irbVal) : null,

            userID: profile.userId as number,
            projectName_th: value?.projectNameTH || null,
            projectName_en: value?.projectNameEN || null,
            researchProjectSummary_th: value?.researchProjectSummaryTH || null,
            researchProjectSummary_en: value?.researchProjectSummaryEN || null,

            projectSubmitTypeID: submittedTypeID,

            facultyID: getStrVal(value.faculty) ? parseInt(getStrVal(value.faculty)!) : null,
            requestPhase: value.numPhase ?? null,
            isTools: value.isPhase === '2' ? value.isTools === '2' : null,

            researcherTypeID: researcherTypeVal ? parseInt(researcherTypeVal) : null,

            titleNameID: value.titleName ? parseInt(value.titleName) : null,
            titleNameOther_th: value.otherTitleNameTH ?? null,
            titleNameOther_en: value.otherTitleNameEN ?? null,

            // เฉพาะอาจารย์ (ไม่ใช่ '1')
            academicPositionID: !isStudent && value.academicPosition ? parseInt(value.academicPosition) : null,
            academicPositionOther_th:
                !isStudent && value.otherAcademicPositionTH ? value.otherAcademicPositionTH : null,
            academicPositionOther_en:
                !isStudent && value.otherAcademicPositionEN ? value.otherAcademicPositionEN : null,

            // เฉพาะนักศึกษา ('1')
            educationLevelID: isStudent && educationLevelVal ? parseInt(educationLevelVal) : null,

            researcherName_th: value.nameTH ?? null,
            researcherName_en: value.nameEN ?? null,
            email: value.email ?? null,
            homePhone: value.homePhone ?? null,
            mobilePhone: value.mobilePhone ?? null,
            fax: value.fax ?? null,

            isDraft: value?.submitType === 'save' ? false : true,

            documentInfo: getDocumentInfo(value),
            documentAdditionalInfo,
            isLanguage_th: !!value.langTH,
            isLanguage_en: !!value.langEN,
            isRequestCertificatePaper: value.isCertificatePaperList === '1',
            isDr: !isStudent && !!value.isDr,
            projectAdvisor: value?.projectAdvisor ?? null,
            projectAdvisorEmail: value?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: value?.projectAdvisorEmailReserve ?? null,
            coResearcher: getResearchers(value.coResearcher),
        }

        return parameterForSave
    }
    const getResearchers = (list: requestFormType.ResearcherInfo[] = []): REQServiceTypes.ResearcherRequest[] => {
        return list.map((v, i) => {
            const researcherTypeVal = getStrVal(v.researcherType)
            const isStudent = researcherTypeVal === '1'
            const educationLevelVal = getStrVal(v.educationLevel)

            return {
                id: i + 1,
                researcherRoleTypeId: i < 1 ? 1 : 2,
                researcherTypeId: researcherTypeVal ? parseInt(researcherTypeVal) : null,
                educationLevelId: isStudent && educationLevelVal ? parseInt(educationLevelVal) : null,
                titleNameId: v.titleName ? Number(v.titleName) : null,
                otherTitleNameTh: v.otherTitleNameTH ?? null,
                otherTitleNameEn: v.otherTitleNameEN ?? null,
                isAcademicPhd: v.isDr ?? null,
                academicPositionId: !isStudent && v.academicPosition ? Number(v.academicPosition) : null,
                otherAcademicPositionTh: !isStudent && v.otherAcademicPositionTH ? v.otherAcademicPositionTH : null,
                otherAcademicPositionEn: !isStudent && v.otherAcademicPositionEN ? v.otherAcademicPositionEN : null,
                nameTh: v.nameTH ?? null,
                nameEn: v.nameEN ?? null,
                homePhoneNumber: v.homePhone ?? null,
                phoneNumber: v.mobilePhone ?? null,
                fax: v.fax ?? null,
                email: v.email ?? null,
            }
        })
    }

    const handleClickSubmit = (value: requestFormType.MyRequestFormType) => {
        submitValueRef.current = value

        const parameterForSave: REQServiceTypes.CreateProjectRequestType = getParameterForSave(value)

        parameterForSaveRef.current = parameterForSave

        switch (value.submitType) {
            case 'save':
                // code block
                isDraftRef.current = false
                handleSave()
                break
            case 'draft':
                // code block
                isDraftRef.current = true
                handleSaveDraft()
                break
            default:
                break
        }
    }
    const checkRequirePDF = (documentInfo: MyFileDataType[]) => {
        let isRequirePDF = false

        for (let i = 0; i < documentInfo?.length; i++) {
            if (!isRequirePDF) {
                for (let j = 0; j < documentInfo[i]?.fileTokenInfo.length; j++) {
                    if (documentInfo[i]?.fileTokenInfo[j].fileExtension === 'pdf') {
                        isRequirePDF = false
                        break
                    } else {
                        isRequirePDF = true
                    }
                }
            }
        }
        return isRequirePDF
    }
    const validateRequiredUploadFile = (uploadFile: Array<{ uploadFileObj: any }>, skipValidate: boolean = false) => {
        let isValid = true
        if (!skipValidate) {
            uploadFile?.every(({ uploadFileObj: file }) => {
                if (file?.isRequired && file?.fileList?.length === 0) {
                    //เป็นหัวข้อที่มีการ required แต่ว่าไม่ upload เอกสาร
                    isValid = false
                    return false //break
                }
                return true //continue
            })

            if (!isValid) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get2Element('ALERT.CONTENT.PLEASE_UPLOAD_REQUIRED_TOPIC', [
                        '<label style="color: red;">*</label>',
                    ]) as any,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }
        }
        return isValid
    }
    const handleSave = async () => {
        if (validateRequiredUploadFile(submitValueRef.current.uploadFile)) {
            if (parameterForSaveRef.current?.documentInfo?.length === 0) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.UPLOAD_AT_LEAST_1_FILE'),
                    type: 'alert-message',
                })
            } else {
                const isRequirePDF = checkRequirePDF(parameterForSaveRef.current?.documentInfo)

                const allAdditionalDocTopicsHavePdf = checkAllAdditionalDocTopicsHavePdf(
                    parameterForSaveRef.current?.documentAdditionalInfo,
                )
                const isEmptyPage = checkSubtopic(parameterForSaveRef.current?.documentInfo)

                if (isRequirePDF || !allAdditionalDocTopicsHavePdf) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE'),
                        type: 'alert-message',
                    })
                } else if (isEmptyPage) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.PLEASE_COMPLETE_PAGE'),
                        type: 'alert-message',
                    })
                } else {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.NEED_TO_SAVE_WITH_NOTI'),
                        type: 'alert-confirm',
                        onClickConfirm: handleClickConfirmSave,
                    })
                }
            }

            dialogTwoRef.current?.openDialog()
        }
    }

    const checkSubtopic = (documentInfo: MyFileDataType[]) => {
        let isEmptyPage = false

        //หาว่าหัวข้ออัปโหลดเอกสารมีให้อัปโหลดหัวข้อย่อยมั้ย
        const docTopic = manageProjectStore.documentTopic?.filter((item) => item.subtopic.length > 0)

        //ถ้ามีให้เข้าไปเช็คตามเงื่อนไข if
        if (docTopic?.length) {
            // วน loop หัวข้อที่มีให้อัปโหลดเอกสารหัวข้อย่อย
            docTopic.forEach((mainTopic) => {
                // วน loop หัวข้อที่มีการอัปโหลดเอกสารเข้ามา
                documentInfo.forEach((itm) => {
                    // เช็คว่าเอกสารที่มีการอัปโหลดเข้ามาใช่เอกสารที่มีหัวข้อย่อยให้อัปโหลดหรือป่าว
                    if (mainTopic.id === itm.documentTopicID) {
                        // เช็คว่าหัวข้อย่อยที่อัพโหลดเข้ามาครบมั้ย
                        if (itm.subtopic?.length != mainTopic.subtopic.length) {
                            isEmptyPage = true
                        } else {
                            // เช็คว่าที่อัปมาครบมีช่องไหนกรอกเป็น ช่องว่างมั้ย
                            const chkEmpty = itm.subtopic.find(
                                (e) => e.page == null || e.page == '' || e.page == undefined,
                            )
                            if (chkEmpty) {
                                isEmptyPage = true
                            }
                        }
                    }
                })
            })
        }

        return isEmptyPage
    }

    const handleSaveDraft = async () => {
        handleClickConfirmSave()
    }
    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogTwoRef.current = func
    }

    const handleClickConfirmSave = async () => {
        try {
            loadingOpen()
            let res
            if (isApproveWithComment) {
                const parameterEditAfterReview = _.pick(parameterForSaveRef.current, [
                    'documentInfo',
                    'isDraft',
                    'projectID',
                    'submittedID',
                ])
                res = await callWebService.projectApproveWithComment(parameterEditAfterReview)
            } else {
                //Flow ยื่นโครงการใหม่ + Flow แก้ไขหลังพิจารณา
                res = await callWebService.createNewProject(parameterForSaveRef.current)
            }

            setConfigDialog({}) //clear function dialog
            dialogTwoRef.current?.closeDialog()
            if (formMode === 'EDIT') {
                if (onSaveComplete) {
                    onSaveComplete(res?.status, parameterForSaveRef.current?.isDraft as boolean)
                }
                setNewUploadFile(res?.result?.projectInfo?.projectID, res?.result?.projectInfo?.submittedID)
            } else if (formMode === 'CREATE') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                    onAfterClose: handleAfterCloseCreateSuccess,
                })
                appFolderAndTabAction.resetTabDirty()
                dialogTwoRef.current?.openDialog()
                projectIDRef.current = res.result?.projectInfo?.projectID
                submittedIDRef.current = res.result?.projectInfo?.submittedID
                irbRef.current = res.result?.projectInfo?.irb
            }
        } catch (err) {
        } finally {
            loadingClose()
        }
    }

    const handleAfterCloseCreateSuccess = () => {
        setConfigDialog({}) //clear function dialog
        //เล่นใน mode create save เสร็จจะต้องไปเข้าหน้า Edit/View
        const encryptedProjectID = encryptionAES(`${projectIDRef.current}`)
        const encryptedSubmittedID = encryptionAES(`${submittedIDRef.current}`)
        const path = generatePath(RoutePath.manageProjectEdit, {
            projectID: encryptedProjectID,
            submittedID: encryptedSubmittedID,
        })
        history.push({
            pathname: path, // editMode
        })
    }

    const handleChangeFaculty = (irb?: string) => {
        if (irb) {
            const submittedTypeID =
                manageProjectStore.projectData?.submitTypeInfo?.value ?? constSubmittedType.firstSubmitConsideration

            getDocumentTopicLut(parseInt(irb), submittedTypeID)
        }
    }

    const handleChangeResearcherType = (val?: string) => {
        if (val) {
            filterTopicUpload(val)
            researcherTypeRef.current = val
        }
    }

    const filterTopicUpload = (val: string) => {
        let docTopic: ResultDocumentTopicLut[] = []
        if (documentTopicRef.current) {
            let isDocTopic = documentTopicRef.current
           
            if (isDocTopic.length > 1) {
                docTopic = [...isDocTopic]
                // if (val === '1') {
                //     if(topicForLecturer.length > 0){
                //         topicForLecturer.forEach((element) => {
                //             docTopic = docTopic?.filter((item) => {
                //                 return item.id !== element.id
                //             })
                //         })
                //     }
                // } else {
                //     if(topicForStudent.length > 0){
                //         topicForStudent.forEach((element) => {
                //             docTopic = docTopic?.filter((item) => {
                //                 return item.id !== element.id
                //             })
                //         })
                //     }
                // }
                
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1 }
                })

                manageProjectAction.setDocumentTopic(docTopic)
            }
        }
    }

    const getDocumentTopicLut = async (irb: number, submittType: number) => {
        let submittedTypeID = projectSubmittedTypeID ? projectSubmittedTypeID : submittType
        if (irb) {
            const res = await callLookup.callDocumentTopicLut(irb, submittedTypeID)
            if (res.status === 1) {
                manageProjectAction.setDocumentTopic(res.result)
                documentTopicRef.current = res.result
            } else {
                manageProjectAction.setDocumentTopic([])
                documentTopicRef.current = []
            }

            if (researcherTypeRef.current) {
                filterTopicUpload(researcherTypeRef.current)
            }

            //กรองหัวข้อตามประเภทนักวิจัย กรณีที่มีข้อมูล projectData
            if (manageProjectStore.projectData?.researcherTypeInfo?.value) {
                const researcherTypeID = manageProjectStore.projectData?.researcherTypeInfo.value
                researcherTypeRef.current = researcherTypeID.toString()
                filterTopicUpload(researcherTypeID.toString())
            }
        }
    }

    const createInitialUploadFile = () => {
        // ป้องกันการ set ข้อมูลว่างเมื่อ documentTopic ยังไม่ load เสร็จ
        if (!documentTopic || documentTopic.length === 0) return

        let documentInfo = manageProjectStore.projectData?.documentInfo
        let latestDocument = manageProjectStore.projectData?.latestDocument
        let uploadFileInit = documentTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<UploadFileObjType>

        uploadFileInit?.forEach((itm: UploadFileObjType) => {
            documentInfo?.forEach((docInfo: any) => {
                if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                    let fileList = docInfo?.fileInfo?.map((file: any) => ({
                        documentTopicID: docInfo.topicID,
                        fileToken: file.fileToken, //fileToken
                        filename: file.filename,
                        fileID: file.fileID, //fileToken
                        path: file.path,
                        replaceFileID: file.replaceFileID,
                    }))
                    itm.uploadFileObj.fileList = fileList
                    const subtopic = docInfo.subtopic?.map((sub: any) => ({
                        page: sub.page,
                        documentTopicID: docInfo.topicID,
                        subtopicID: sub.subtopicID,
                    }))
                    itm.uploadFileObj.subTopicPageList = subtopic
                }
            })
        })

        //Section Replace File
        if (latestDocument && latestDocument?.length > 0) {
            uploadFileInit?.forEach((initFileItm) => {
                //loop structure init file

                latestDocument?.forEach((docItm) => {
                    //loop document topic
                    const docFileInfo = docItm.fileInfo

                    docFileInfo?.forEach((replaceFileItm: any) => {
                        //loop file in document
                        const lstReplaceFileGroup: Array<any> = replaceFileItm.latestFileList
                        const replaceFile = lstReplaceFileGroup.filter((file) => file.no !== null)?.[0] //ไฟล์เก่าที่ถูกแทนที่
                        const replaceFileBy = lstReplaceFileGroup.filter((file) => file.no === null)?.[0] //ไฟล์ใหม่ที่นำมาแทนที่
                        if (replaceFile && replaceFileBy) {
                            if (docItm.topicID === initFileItm.uploadFileObj.documentTopicID) {
                                initFileItm.uploadFileObj.fileList = [
                                    ...initFileItm.uploadFileObj.fileList,
                                    {
                                        documentTopicID: docItm.topicID,
                                        fileToken: replaceFileBy.fileToken, //fileToken
                                        filename: replaceFileBy.filename,
                                        fileID: replaceFileBy.fileID, //fileToken
                                        path: replaceFileBy.path,
                                        replaceFileID: replaceFileBy.replaceFileID,
                                    } as any,
                                ]
                                const subtopic = docItm.subtopic?.map((sub: any) => ({
                                    page: sub.page,
                                    documentTopicID: docItm.topicID,
                                    subtopicID: sub.subtopicID,
                                }))
                                //ถ้า latestDocument ไม่มีข้อมูล subtopic (เช่น record ของไฟล์ที่ถูกแทนที่ไม่มีข้อมูล page)
                                //ห้าม overwrite ทับค่า subTopicPageList ที่เคยตั้งไว้แล้วจาก documentInfo ด้านบน
                                if (subtopic && subtopic.length > 0) {
                                    initFileItm.uploadFileObj.subTopicPageList = subtopic
                                }
                            }
                        }
                    })
                })
            })
        }

        if (uploadFileInit?.length > 0) {
            uploadFileInit = uploadFileInit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }

        setInitialUploadFile(uploadFileInit)
    }

    const setNewUploadFile = async (projectID: number, submittedID: number) => {
        const projectData = await tabAndFolderHook.getProjectByID(projectID, submittedID)
        let documentInfo = projectData?.documentInfo
        let latestDocument = projectData?.latestDocument
        let uploadFileInit = documentTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<UploadFileObjType>

        uploadFileInit?.forEach((itm: UploadFileObjType) => {
            documentInfo?.forEach((docInfo: any) => {
                if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                    let fileList = docInfo?.fileInfo?.map((file: any) => ({
                        documentTopicID: docInfo.topicID,
                        fileToken: file.fileToken, //fileToken
                        filename: file.filename,
                        fileID: file.fileID, //fileToken
                        path: file.path,
                    }))
                    itm.uploadFileObj.fileList = fileList
                    const subtopic = docInfo.subtopic?.map((sub: any) => ({
                        page: sub.page,
                        documentTopicID: docInfo.topicID,
                        subtopicID: sub.subtopicID,
                    }))
                    itm.uploadFileObj.subTopicPageList = subtopic
                }
            })
        })

        //Section Replace File
        if (latestDocument && latestDocument?.length > 0) {
            uploadFileInit?.forEach((initFileItm) => {
                //loop structure init file

                latestDocument?.forEach((docItm) => {
                    //loop document topic
                    const docFileInfo = docItm.fileInfo

                    docFileInfo?.forEach((replaceFileItm: any) => {
                        //loop file in document
                        const lstReplaceFileGroup: Array<any> = replaceFileItm.latestFileList
                        const replaceFile = lstReplaceFileGroup.filter((file) => file.no !== null)?.[0] //ไฟล์เก่าที่ถูกแทนที่
                        const replaceFileBy = lstReplaceFileGroup.filter((file) => file.no === null)?.[0] //ไฟล์ใหม่ที่นำมาแทนที่
                        if (replaceFile && replaceFileBy) {
                            if (docItm.topicID === initFileItm.uploadFileObj.documentTopicID) {
                                initFileItm.uploadFileObj.fileList = [
                                    ...initFileItm.uploadFileObj.fileList,
                                    {
                                        documentTopicID: docItm.topicID,
                                        fileToken: replaceFileBy.fileToken, //fileToken
                                        filename: replaceFileBy.filename,
                                        fileID: replaceFileBy.fileID, //fileToken
                                        path: replaceFileBy.path,
                                        replaceFileID: replaceFileBy.replaceFileID,
                                    } as any,
                                ]

                                const subtopic = docItm.subtopic?.map((sub: any) => ({
                                    page: sub.page,
                                    documentTopicID: docItm.topicID,
                                    subtopicID: sub.subtopicID,
                                }))
                                //ถ้า latestDocument ไม่มีข้อมูล subtopic (เช่น record ของไฟล์ที่ถูกแทนที่ไม่มีข้อมูล page)
                                //ห้าม overwrite ทับค่า subTopicPageList ที่เคยตั้งไว้แล้วจาก documentInfo ด้านบน
                                if (subtopic && subtopic.length > 0) {
                                    initFileItm.uploadFileObj.subTopicPageList = subtopic
                                }
                            }
                        }
                    })
                })
            })
        }

        if (uploadFileInit?.length > 0) {
            uploadFileInit = uploadFileInit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }
        setInitialUploadFile(uploadFileInit)
    }
    const handleClickClose = () => {
        history.push(RoutePath.manageProject)
    }
    const handleDirtyChange = (props: any) => {
        const paramsDirty = {
            tabDirty: isViewMode ? false : props.dirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }
    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        isDraftRef.current = true

        if (valuesForm) {
            const values = { ...valuesForm.current } as requestFormType.MyRequestFormType
            const parameterForSave: REQServiceTypes.CreateProjectRequestType = getParameterForSave(values)
            parameterForSaveRef.current = parameterForSave
            newTabSelectedRef.current = newTabSelected
            tabSelectedIndexRef.current = tabIndex
            handleSaveDraft()
        }
    }

    const handleDeleteProject = () => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.WARNING'),
            content: translate.get('ALERT.CONTENT.NEED_TO_DELETE'),
            type: 'alert-confirm',

            onClickConfirm: async () => {
                if (manageProjectStore?.projectData?.projectID) {
                    const res = await callWebService.deleteProject(manageProjectStore?.projectData?.projectID)
                    setConfigDialog({}) //clear function dialog
                    history.push('/manage-project')
                }
            },
        })
        dialogTwoRef.current?.openDialog()
    }

    const chkDisplayBTNDeleteProject: boolean =
        (initialData?.projectSubmitType &&
            checkPermission.chkDisplayBTNDeleteProject(parseInt(initialData?.projectSubmitType.value)) &&
            initialData?.isDraft &&
            manageProjectStore.projectData?.verifyDocument == null) ||
        false

    return {
        isDraftData: chkDisplayBTNDeleteProject,
        initialUploadFile,
        configDialog,
        onRefDialogTwo,
        selectedIrb,
        configLoading,
        valuesForm,
        isApproveWithComment,
        projectData: manageProjectStore.projectData,
        initialDataValue,
        researcherTypeRef,
        handleDirtyChange,
        onClickDeleteProject: handleDeleteProject,
        onClickSubmit: handleClickSubmit,
        onClickCancel: handleClickCancel,
        onClickClose: handleClickClose,
        handleChangeFaculty: handleChangeFaculty,
        onChangeResearcherType: handleChangeResearcherType,
    }
}

export default useRequestForm
